import { render } from "./ExpertsTab.vue?vue&type=template&id=76241bee"
import script from "./ExpertsTab.vue?vue&type=script&lang=js"
export * from "./ExpertsTab.vue?vue&type=script&lang=js"

import "./ExpertsTab.vue?vue&type=style&index=0&id=76241bee&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__